// 003 → 004 hand-off (FR-021, FR-022; contracts/join-handoff.md; data-model §6): one in-memory slot,
// never stored. `school.id` is display / same-school only; requests send the code (BR-14).
import type { Href } from "expo-router";
import type { Api } from "@/api/types";

export type JoinHandoff = {
  code: string;
  source: Api["JoinSource"];
  school: Api["SchoolByCode"];
};

let slot: JoinHandoff | null = null;

export const handoff = {
  put(h: JoinHandoff): void {
    slot = h;
  },
  /** Once; null after a reload or for another code. */
  take(code: string): JoinHandoff | null {
    if (slot === null || slot.code !== code) return null;
    const value = slot;
    slot = null;
    return value;
  },
};

export function addStudentHref(code: string, source: Api["JoinSource"]): Href {
  return `/add-student?code=${code}&via=${source}` as Href;
}
